import { Component, Host, h, Prop, State } from '@stencil/core';
import { localizeNumbers } from '../../../utils/utils';

@Component({
  tag: 'afs-current-draw',
  styleUrl: 'afs-current-draw.sass',
  shadow: true,
})
export class AfsCurrentDraw {

  @Prop() drawUrl : string = "https://ccbqel594l.execute-api.us-west-2.amazonaws.com/v1/3af28ebf/totaldrawamount";
  @Prop() fixedValue : number;
  @Prop() color : string = "#FFFFFF";
  @Prop() backgroundColor : string = "#222222";
  @State() drawVal : string | number = 0;

  async loadDrawVal() {
    try {
      const response = await fetch(this.drawUrl);
      const data = await response.json();
      this.drawVal = localizeNumbers(data.total, true);
    } catch (err) {
      console.warn(`Cannot Retrieve Draw URL Data : ${err}`);
      // this.drawVal = 0;
    }
  }

  async componentWillLoad() {
    if (typeof this.fixedValue !== 'undefined') return;
    await this.loadDrawVal()
    setInterval(async () => await this.loadDrawVal(), 60000);
  }

  render() {
    return (
      <Host style={{
        color: this.color,
        backgroundColor: this.backgroundColor,
      }}>
        <h1>{this.fixedValue ? localizeNumbers(this.fixedValue, true) : this.drawVal}</h1>
      </Host>
    );
  }

}
